export const WORK_ORDER_STATUS = {
  NEW: 'new',
  VOID: 'void',
  ACCEPTED: 'accepted',
  COMPLETED: 'completed',
  REQUIRES_QUOTE: 'requires-quote',
  REQUIRES_REVISION: 'requires-revision',
  PENDING_APPROVAL: 'pending-approval',
  SCHEDULED: 'scheduled',
  APPROVED: 'approved',
  PENDING_PAYOUT: 'pending-payout',
  UNKNOWN: 'unknown',
} as const

export const WORK_ORDER_SCHEDULE_TYPES = {
  UNSCHEDULED: 'unscheduled',
  SINGLE_DAY: 'single_day',
  MULTI_DAY: 'multi_day',
} as const
